export default "__VITE_ASSET__444abc04__"